module.exports = __webpack_public_path__ + "static/img/img41.530a5e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zone/img41.png
// module id = +9gQ
// module chunks = 1